import React from "react";

const cfg = {
  red:   { bg: "bg-fresh-red-soft",   text: "text-fresh-red-text",   dot: "bg-fresh-red" },
  yellow:{ bg: "bg-fresh-yellow-soft",text: "text-fresh-yellow-text",dot: "bg-fresh-yellow" },
  green: { bg: "bg-fresh-green-soft", text: "text-fresh-green-text", dot: "bg-fresh-green" },
  expired:{ bg: "bg-zinc-200",        text: "text-zinc-700",         dot: "bg-zinc-500" },
};

export function FreshnessBadge({ freshness, daysLeft, testId }) {
  const c = cfg[freshness] || cfg.expired;
  let label;
  if (freshness === "expired" || daysLeft < 0) label = `Expired ${Math.abs(daysLeft)}d ago`;
  else if (daysLeft === 0) label = "Today";
  else if (daysLeft === 1) label = "1 day";
  else label = `${daysLeft} days`;
  return (
    <div
      data-testid={testId}
      className={`inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-xs font-bold ${c.bg} ${c.text}`}
    >
      <span className={`w-2 h-2 rounded-full ${c.dot}`} />
      {label}
    </div>
  );
}

export default FreshnessBadge;
